import React, { useState } from "react"
import VizSensor from "react-visibility-sensor"
import { getSrc } from "gatsby-plugin-image"
import { Link } from "react-scroll"

import { Cta } from "@components/common/cta/Cta"
import Rays from "@assets/images/rays.svg"

import { Props } from "./CompetitionProductHeader.interface"
import * as s from "./CompetitionProductHeader.module.scss"

export const CompetitionProductHeader = ({ data }: Props) => {
  const { title, blurb, enterCtaText, direction, image, color } = data

  const [visibilityClass, setVisibilityClass] = useState(false)

  const onChangeVisibility = isActive => {
    if (isActive) {
      setVisibilityClass(true)
    }
  }

  let wHeight = 1000

  if (typeof window !== `undefined`) {
    wHeight = window.innerHeight
  }

  const rowDirection =
    direction === "RTL"
      ? s.CompetitionProductHeader__RTL
      : direction === "LTR"
        ? s.CompetitionProductHeader__LTR
        : null

  const colorClass = color => {
    switch (color) {
      case "black":
        return s.CompetitionProductHeader__black
        break
      case "red":
        return s.CompetitionProductHeader__red
        break
      case "yellow":
        return s.CompetitionProductHeader__yellow
        break
    }
  }

  return (
    <VizSensor partialVisibility onChange={e => onChangeVisibility(e)}>
      <div
        className={`
      ${s.CompetitionProductHeader} 
      ${rowDirection} 
      ${colorClass(color)}
      ${visibilityClass && s.CompetitionProductHeader___isVisible}
      `}
      >
        <div
          className={`${s.CompetitionProductHeaderSplitSection} ${s.CompetitionProductHeaderSplitSection__media}`}
        >
          <img
            className={s.CompetitionProductHeaderImage}
            src={
              image && image.localFile
                ? getSrc(image.localFile)
                : image.sourceUrl
            }
            alt={image && image.altText ? image.altText : title}
          />

          <img src={Rays} className={s.CompetitionProductHeaderImageRays} />
        </div>

        <div className={s.CompetitionProductHeaderSplitSection}>
          <div className={s.CompetitionProductHeaderSplitSection__textInner}>
            {title && (
              <h2 className={s.CompetitionProductHeader__title}>{title}</h2>
            )}

            {blurb && (
              <p className={s.CompetitionProductHeader__blurb}>{`${blurb}`}</p>
            )}

            <div className={s.CtaButtons}>
              <Link
                to="klaviyoForm"
                spy={true}
                smooth={true}
                offset={wHeight * -0.25}
              >
                <Cta title={enterCtaText} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </VizSensor>
  )
}
